import { render } from "./EditPayment3.vue?vue&type=template&id=b76ffed6"
import script from "./EditPayment3.vue?vue&type=script&lang=js"
export * from "./EditPayment3.vue?vue&type=script&lang=js"

import "./EditPayment3.vue?vue&type=style&index=0&id=b76ffed6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__